const e = "Aparthotels", s = "Appartements", t = "Business", o = "Campings", n = "Couple", i = "Famille", r = "Amis", a = "Auberges", l = "Hôtels", u = "Resorts", c = "Restaurants", m = {
  "{num} reviews": "{num} avis",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} de {location}",
  "All languages": "Toutes les langues",
  "All traveler types": "Tous les types de voyageurs",
  Aparthotels: e,
  Apartments: s,
  "Arrow icon": "Icône de la flèche",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "basé sur {number} avis",
  Business: t,
  Campsites: o,
  Couple: n,
  Family: i,
  Friend: r,
  "Highlighted reviews": "Avis Clients",
  Hostels: a,
  Hotels: l,
  "Information icon": "Icône d'information",
  "No reviews found": "Aucun résultat trouvé",
  "Pet-friendly": "Acceptation des animaux domestiques",
  "Posted on {reviewer}": "Publié sur {reviewer}",
  "Read Reviews": "Voir les avis",
  Resorts: u,
  Restaurants: c,
  "Review Summary": "Résumé d'avis clients",
  "Reviews by Source": "Avis par source"
};
export {
  e as Aparthotels,
  s as Apartments,
  t as Business,
  o as Campsites,
  n as Couple,
  i as Family,
  r as Friend,
  a as Hostels,
  l as Hotels,
  u as Resorts,
  c as Restaurants,
  m as default
};
//# sourceMappingURL=fr.DJJylh3O.js.map
